import React from 'react';
import NewsCard from './NewsCard';
import SubsctibeCard from './SubscribeCard';
import './styles.scss';

const NewsCards = ({ posts = [], subscribeTitle, subscribeDescription, subscribePolicy }) => (
    <div className="news-cards">
        {posts.map((item, index) => (
            <NewsCard key={item.title} data={item} big={index === 0} />
        ))}
        {/* TODO Через 6 або менше постів */}
        <SubsctibeCard title={subscribeTitle} description={subscribeDescription} policy={subscribePolicy} />
    </div>
);

export default NewsCards;
